import { render, staticRenderFns } from "./attachmentsSnackbarAlert.vue?vue&type=template&id=0b198229"
import script from "./attachmentsSnackbarAlert.vue?vue&type=script&lang=ts"
export * from "./attachmentsSnackbarAlert.vue?vue&type=script&lang=ts"
import style0 from "./attachmentsSnackbarAlert.vue?vue&type=style&index=0&id=0b198229&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports